import React from 'react';
import styled from 'styled-components';

function Settings() {
  return (
    <Wrapper>
      Settings
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 20px 30px;
`;

export default Settings;
